/**
 * 查看弹窗增强：空值显示 "--"；上传项铺满整行
 * 注意：不要用 innerHTML 替换金额等 Vue 绑定节点，否则多条「查看」会串数据
 */
function isBlank(v) {
  return v == null || String(v).trim() === "";
}

function ensureEmptyText(parent, beforeEl) {
  if (!parent || parent.querySelector(".ps-see-empty-text")) return;
  const span = document.createElement("span");
  span.className = "ps-see-empty-text";
  span.textContent = "--";
  if (beforeEl && beforeEl.parentNode === parent) {
    parent.insertBefore(span, beforeEl);
  } else {
    parent.appendChild(span);
  }
}

function enhanceSeeModal(root) {
  if (!root) return;
  const body = root.querySelector(".ant-modal-body") || root;

  // 金额控件按内容收缩，单位（.surplus-money）用 CSS 紧挨显示，不破坏 Vue 绑定
  body.querySelectorAll(".ant-input-number-disabled .ant-input-number-input").forEach((el) => {
    const wrap = el.closest(".ant-input-number");
    const raw = String(el.value || "").trim();
    if (isBlank(raw)) {
      el.setAttribute("placeholder", "--");
      el.classList.add("ps-see-empty-input");
      if (wrap) wrap.style.width = "2em";
    } else {
      el.classList.remove("ps-see-empty-input");
      if (wrap) wrap.style.width = `${Math.max(raw.length, 1) + 1}ch`;
    }
  });

  body.querySelectorAll("input.ant-input[disabled], textarea.ant-input[disabled]").forEach((el) => {
    if (el.closest(".ant-upload")) return;
    if (el.closest(".ant-input-number")) return;
    if (isBlank(el.value)) {
      el.setAttribute("placeholder", "--");
      el.classList.add("ps-see-empty-input");
    } else {
      el.classList.remove("ps-see-empty-input");
      if (el.getAttribute("placeholder") === "--") {
        el.removeAttribute("placeholder");
      }
    }
  });

  body.querySelectorAll(".ant-select-disabled").forEach((sel) => {
    const selected = sel.querySelector(".ant-select-selection-selected-value");
    if (selected && !isBlank(selected.textContent)) {
      const ph = sel.querySelector(".ant-select-selection__placeholder.ps-see-empty-ph");
      if (ph) ph.remove();
      return;
    }
    let ph = sel.querySelector(".ant-select-selection__placeholder");
    if (!ph) {
      const rendered = sel.querySelector(".ant-select-selection__rendered");
      if (!rendered) return;
      ph = document.createElement("span");
      ph.className = "ant-select-selection__placeholder";
      rendered.appendChild(ph);
    }
    ph.textContent = "--";
    ph.classList.add("ps-see-empty-ph");
  });

  body.querySelectorAll(".ant-radio-group").forEach((group) => {
    if (group.querySelector(".ant-radio-wrapper-checked")) {
      const empty = group.querySelector(".ps-see-empty-text");
      if (empty) empty.remove();
      return;
    }
    ensureEmptyText(group);
  });

  const formItems = Array.from(body.querySelectorAll(".ant-form-item")).filter(
    (item) => !item.closest(".ant-form-item .ant-form-item")
  );
  const forceFull = formItems.length <= 2;
  formItems.forEach((item) => {
    if (
      forceFull ||
      item.querySelector(".ant-upload") ||
      item.querySelector("textarea") ||
      item.querySelector(".avatar-uploader") ||
      item.querySelector(".w-e-text-container")
    ) {
      item.style.gridColumn = "1 / -1";
    }

    const uploadList = item.querySelector(".ant-upload-list");
    if (!uploadList) return;
    if (uploadList.querySelector(".ant-upload-list-item")) {
      const empty = item.querySelector(".ps-see-empty-text");
      if (empty) empty.remove();
      uploadList.querySelectorAll(".ant-upload-list-item-name").forEach((nameEl) => {
        nameEl.style.maxWidth = "none";
        nameEl.style.overflow = "visible";
        nameEl.style.whiteSpace = "normal";
      });
      return;
    }
    const control =
      item.querySelector(".ant-form-item-children") ||
      item.querySelector(".ant-form-item-control");
    ensureEmptyText(control, uploadList);
  });
}

function scheduleEnhance(node) {
  const run = () => enhanceSeeModal(node);
  requestAnimationFrame(run);
  setTimeout(run, 30);
  setTimeout(run, 120);
  setTimeout(run, 320);
}

function bind() {
  const run = (node) => {
    if (!node || !node.querySelectorAll) return;
    if (node.classList && node.classList.contains("ps-see-form-modal")) {
      scheduleEnhance(node);
    }
    node.querySelectorAll(".ps-see-form-modal").forEach((el) => scheduleEnhance(el));
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        run(node);
      });
      if (
        m.type === "attributes" &&
        m.target &&
        m.target.classList &&
        m.target.classList.contains("ps-see-form-modal")
      ) {
        run(m.target);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
}

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
}

export default { enhanceSeeModal };
